import Mmmm from 'crypto-js';

class Mistiko {
    getMmm() {
        return Mmmm;
    }
}

export { Mistiko };
export default new Mistiko();